

exports.__esModule = true;
exports.$xoCardExpiryDirective = undefined;

var _squid = require('squid');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/floating-label/directive');

require('xo-ui-components/src/directionality/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
    tag: 'xo-card-expiry',
    template: _template2['default'],

    props: {
        expiryMonth: {
            type: 'var',
            required: false
        },
        expiryYear: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.expiryFormat = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);

            if (this.expiryMonth && this.expiryYear) {
                if (this.expiryFormat === 'MMYY') {
                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
                } else if (this.expiryFormat === 'MMYYYY') {
                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
                }
            }

            if (this.expiryFormat === 'MMYY') {
                this.maxlength = 5;
                this.expiryMask = '99/99';
            } else {
                this.maxlength = 7;
                this.expiryMask = '99/9999';
            }

            // If Japanese, we are falling back to "tel" keyboard.
            if (_squid.$locale.country === 'JP') {
                this.keyType = 'tel';
            } else {
                this.keyType = 'text';
            }

            this.formatExpiry = function (event) {
                var key = event.keyCode || event.charCode;
                var $el = $(event.target);
                var val = $el.val().replace(/[^0-9\/]/gi, '');
                var strokes = val.length;

                // Ignore delete keys
                if (key === 8 || key === 46) {
                    return;
                }

                // after two characters add a slash char
                if (strokes === 2) {
                    val += '/';
                }

                _this.expiryDate = val;
                $el.mask(_this.expiryMask);
            };

            var currentYear = new Date().getFullYear().toString();
            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });

            this.validate = function (expiryDate) {
                if (!expiryDate) {
                    return;
                }

                var month = void 0,
                    year = void 0,
                    unformatted = void 0;
                var isValid = false;

                unformatted = expiryDate.replace(/[^0-9]/gi, '');
                if (unformatted.length > 3) {
                    month = unformatted.substring(0, 2);
                    if (_this.expiryFormat === 'MMYY') {
                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
                    } else if (_this.expiryFormat === 'MMYYYY') {
                        year = unformatted.substring(2, 6);
                    }

                    isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
                }

                _this.expiryYear = year;
                _this.expiryMonth = month;

                return isValid;
            };
        }
    }
});

angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/cardExpiry/directive.js
// module id = ./components/xo-wallet-components/src/add-card/cardExpiry/directive.js
// module chunks = 1